import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getProductListingById } from "../api/pyxis";
import { IAPIError } from "../interfaces/common";
import { IProductDetails } from "../interfaces/product";

export const productDetailsQueryKey = ['productDetails'] as const;

export const useProductDetails = (id: string, enabled?: boolean):
  UseQueryResult<IProductDetails, IAPIError> => {
  return useQuery<IProductDetails, IAPIError>({
    queryKey: productDetailsQueryKey,
    queryFn: ({ signal }) => getProductListingById(id, signal),
    enabled
  });
};
